export default __webpack_public_path__ + "static/media/eye.aa614c89.svg";